<template>
  <div class="page">
    <div class="header header_3">
      <a class="back" href="javascript:history.back()"></a>
    </div>
    <div class="content">
      <h3>小黑屋云写作隐私政策</h3>
      <div>
        <p style="text-align: right;">本版发布日期：2019年6月15日</p>
        <p style="text-align: right;">生效日期：2019年7月1日</p>
        <p class="indent">欢迎您使用小黑屋云写作及服务！</p>
        <p class="indent">
          为使用北京中文在线文化传媒有限公司（以下简称
          “中文在线”）提供的小黑屋云写作及服务（以下简称“本软件”、“小黑屋”或“本服务”），您应当阅读并遵守《小黑屋云写作用户个人信息保护及隐私政策协议》（以下简称“本协议”）。
        </p>
        <p class="indent">
          请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。您的使用、登录等行为即视为您已阅读并同意上述协议的约束。
        </p>
        <p class="indent">
          本协议下的条款可由中文在线随时变更，用户须定期审阅本协议。协议条款一旦发生变动，中文在线将会在本页面进行更新，并在小黑屋云写作相关的页面上提示变更内容。变更后的协议一经公布即有效代替原来的协议。如用户在本协议变更后继续使用小黑屋云写作及服务，即视作用户已完全同意变更后的协议。用户可随时在本页面查阅最新用户<b>个人信息</b>保护及隐私政策。
        </p>
        <p class="indent">
          您有违反本协议的任何行为时，中文在线有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
        </p>
        <p class="indent">
          如果您未满18周岁，请在监护人的陪同下阅读本协议及其他上述协议，并事先取得您的家长或法定监护人的同意。
        </p>
        <p>一、定义</p>
        <p class="indent">
          1.1
          小黑屋云写作：是指小黑屋云写作的经营者中文在线向用户提供的码字工具（以下简称"小黑屋"），支持用户使用本软件进行网络文学内容创作
        </p>
        <p class="indent">
          1.2
          用户：是指启用、浏览或上传数据至小黑屋服务的用户，在本协议中更多地称为“您”。
        </p>
        <p class="indent">
          1.3 其他用户：是指除用户本人外与小黑屋服务相关的其他小黑屋用户。
        </p>
        <p>二、协议的范围</p>
        <p class="indent">
          2.1
          本协议是您与中文在线之间关于您在下载、安装、使用、复制本软件中涉及用户<b>个人信息</b>保护及隐私政策等相关事宜所订立的协议。
        </p>
        <p class="indent">
          2.2
          本协议内容同时包括中文在线可能不断发布的关于用户<b>个人信息</b>保护及隐私政策的相关协议、声明、业务规则及公告指引等内容（以下统称为“专项规则”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
        </p>
        <p>三、用户<b>个人信息</b>保护及隐私政策</p>
        <p class="indent">
          3.1
          您使用本服务的部分功能前需要有一个成功注册的小黑屋账号或QQ账户或微信账户或微博账户，并获得该帐户的授权，授权内容包括但不限于：获得该帐户的相关信息（<b>昵称、头像、性别、地区</b>）等。对于您的帐户信息，中文在线将采用专业加密存储与传输方式，保障信息安全，不会擅自收集、使用、透露或公开。您有责任妥善保管您的帐户信息及帐户密码的安全，因您自身的原因导致帐户及密码泄漏，而造成的本服务下相关信息的泄露、篡改、删除等后果，中文在线不承担任何责任。
        </p>
        <p class="indent">
          3.2关于您使用账号的具体规则，请遵守相关账号使用协议（包括但不限于《小黑屋云写作许可及服务协议》）以及中文在线为此发布的其它专项规则。
        </p>
        <p class="indent">
          3.3为了向您提供我们的服务，如售后服务和客户支持等，我们会要求您提供向您提供服务所必需的<b>个人信息</b>(我们将会在本隐私政策中，向您明示收集、使用<b>个人信息</b>的目的、方式、范围、保存期限、和地点，并在获取您的同意后进行信息采集)。如果您不提供<b>个人信息</b>，我们可能无法向您提供我们的产品或服务。对本协议的同意将被视为同意我们收集您的<b>个人信息</b>，并在法律规定及本协议约定的范围内进行使用。
        </p>
        <p class="indent">
          3.3.1收集、使用信息的目的：我们可能会将您的<b>个人信息</b>用于下列目的：(1)提供、处理、维护、改善、开发我们的商品和/或提供给您的服务，包括售后服务和客户支持，以及通过设备提供的服务;
          (2)与您就您的设备、服务或任何普通查询（例如更新、客户咨询支持、我们活动的相关信息、通知）等进行交流;
          (3)允许您在小黑屋平台内公共讨论区上发表评论；(4)分析和开发与我们产品及服务的使用相关的统计信息，以更好地改进我们的产品和服务；(5)向您提供与您更加相关的广告以替代普遍投放的广告;(6)储存并维护与您相关的信息，用于我们运营业务或履行法律义务；(7)在中文在线其他网站及客户端同步存储您的账户使用信息。
        </p>
        <p class="indent">3.3.2 收集、使用信息的范围</p>
        <p class="indent">3.3.2.1我们收集以下各类信息：</p>
        <p class="indent">
          （1）您在注册帐户时填写的信息（例如：昵称、手机号码等）、您在使用服务时上传的信息（例如：<b>姓名、性别、头像、电子邮箱地址、所处地区、生日、收货地址等</b>）。
        </p>
        <p class="indent">
          （2）您通过我们的客服或参加我们举办的活动时所提交的信息以及我们在您使用服务时获取的信息（例如：<b>设备、软件、IP地址、位置、服务日志、通讯日志等</b>）。
        </p>
        <p class="indent">
          （3）我们的部分服务可能需要您提供特定的个人敏感信息（*）来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。
        </p>
        <p>
          *个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的<b>个人信息</b>。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。
        </p>
        <p>
          用户在使用第三方账户登录小黑屋使用服务时，会被自动收集该第三方账户已被明示授权的<b>个人信息</b>（<b>包括但不限于获得该帐户的公开信息、昵称、头像等</b>）。此外用户在使用小黑屋的部分功能或服务（包括售后服务和客户支持），提交申请时需配合提供相关<b>个人信息</b>，<b>如参加抽奖活动，可能会被要求提供手机号码、收件地址等信息</b>。
        </p>
        <p class="indent">
          3.3.2.2对于使用安卓系统的用户，您在使用本软件时，为提供、处理、维护、改善、开发我们的商品和/或提供给您的服务之目的，本软件可能获取您终端设备的如下权限：
        </p>
        <p class="indent">l 允许程序改变WiFi状态</p>
        <p class="indent">l 允许程序写入外部存储,如SD卡上写文件</p>
        <p class="indent">l 允许程序访问网络连接</p>
        <p class="indent">
          l 允许程序获取网络信息状态，如当前的网络连接是否有效
        </p>
        <p class="indent">l 允许程序获取当前WiFi接入的状态以及WLAN热点的信息</p>
        <p class="indent">l 允许程序访问电话状态</p>
        <p class="indent">l 允许程序读取或写入系统设置</p>
        <p class="indent">l 允许程序振动</p>
        <p class="indent">l 创建快捷方式权限</p>
        <p class="indent">l 删除快捷方式权限</p>
        <p class="indent">l 允许程序唤醒机器</p>
        <p class="indent">l 允许程序读取系统底层日志</p>
        <p class="indent">l 允许程序录制声音通过手机或耳机的麦克</p>
        <p class="indent">l 从setting中读取快捷方式信息的权限</p>
        <p class="indent">l 读取外部存储设备权限</p>
        <p class="indent">l 请求访问使用照相设备，支持扫描二维码</p>
        <p class="indent">l 允许程序改变网络连接状态</p>
        <p class="indent">l 允许程序挂载、反挂载外部文件系统</p>
        <p class="indent">l 允许程序在手机屏幕关闭后后台进程仍然运行</p>
        <p class="indent">l 允许程序获取当前或最近执行的任务信息</p>
        <p class="indent">
          l 为使用微信账号登录之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">
          l 为使用用户微博信息分享之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">
          l 为使用QQ账号登录之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">
          l 为使用小黑屋账号登录之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">l 需允许程序获取摄像头权限；</p>
        <p class="indent">l 三星分屏权限。</p>
        <p class="indent">
          3.3.2.3对于使用iOS的用户，您在使用本软件时，为提供、处理、维护、改善、开发我们的商品和/或提供给您的服务之目的，本软件可能获取您终端设备的如下权限：
        </p>
        <p class="indent">l 需要您的同意才能访问相册权限；</p>
        <p class="indent">l 需要您的同意才能使用相机权限，支持扫描二维码；</p>
        <p class="indent">l 需要您的同意才能使用网络权限；</p>
        <p class="indent">
          l 需要您的同意才能使用通知（标记、声音、横幅）权限；
        </p>
        <p class="indent">
          l 为使用微信账号登录之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">
          l 为使用用户微博信息分享之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">
          l 允许程序获取网络信息状态，如当前的网络连接是否有效
        </p>
        <p class="indent">l 允许程序在手机屏幕关闭后后台进程仍然运行</p>
        <p class="indent">l 需要您的同意才能使用摄像头权限；</p>
        <p class="indent">
          l 为使用QQ账号登录之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">
          l 为使用小黑屋账号登录之目的获取用户信息（包括账号的昵称和头像等）；
        </p>
        <p class="indent">
          3.3.2.4<b>为用户提供对账和资产保护等服务而收集、存储、使用用户的购买记录、充值记录等</b>。
        </p>
        <p class="indent">3.3.3 使用及保护信息的方式：</p>
        <p class="indent">
          3.3.3.1
          保护用户<b>个人信息</b>是中文在线的一项基本原则，中文在线将会采取合理的措施保护用户的<b>个人信息</b>。除法律法规规定或本协议另有约定的情形外，未经用户许可中文在线不会向第三方公开、透露用户<b>个人信息</b>。中文在线对相关信息采用专业加密存储与传输方式，保障用户<b>个人信息</b>的安全。
        </p>
        <p class="indent">
          3.3.3.2中文在线将运用各种安全技术和程序建立完善的管理制度来保护您的<b>个人信息</b>，以免遭受未经授权的访问、使用或披露。仅为实现外部处理的目的、或随着我们业务的持续发展，当发生合并、收购、资产转让等交易时，我们可能会与第三方合作伙伴（第三方服务供应商、承包商、代理、广告合作伙伴、应用开发者等）（他们可能并非位于您所在的法域）分享您的<b>个人信息</b>，让他们按照我们的说明、隐私协议以及其他相关的保密和安全措施来为我们处理上述信息。如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全。
        </p>
        <p class="indent">
          3.3.3.3我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何<b>个人信息</b>的行业洞察报告等。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。未经您的同意，中文在线不会向中文在线以外的任何公司、组织和个人披露您的<b>个人信息</b>，但法律法规另有规定或本协议另有约定的除外。
        </p>
        <p class="indent">
          3.3.3.4您理解并同意，在不透露单个用户隐私资料的前提下，我们有权对整个用户数据库进行技术分析并对已进行分析、整理后脱敏的用户数据库进行商业上的利用。
        </p>
        <p class="indent">
          3.4您理解并同意，本软件的某些功能可能会让第三方知晓用户的信息，例如：
          用户自行将相关内容分享至第三方产品/平台时会使第三方知晓您的一些信息，包括但不限于QQ号、QQ昵称、QQ头像、微信昵称、微信头像、分享内容等；而且，分享后您所分享的信息会在您分享的产品/平台（包括但不限于QQ、微信及其他平台）显示。在该产品/平台上第三方可以根据各自产品/平台的设定查看您的信息，包括但不限于QQ号、QQ昵称、QQ头像、微信昵称、微信头像、分享内容。如果您不愿意让第三方知晓您的信息，请您不要使用本软件的这些功能；您使用本软件的这些功能视为您同意第三方知晓您的这些信息。
        </p>
        <p class="indent">
          3.5
          您理解并同意，在使用本软件的一些场景中，包括但不限于参加抽奖活动时我们需要收集您的手机号码、收件地址等信息以便为您提供如寄送奖品等服务，我们会在收集信息页面请您配合提供相关<b>个人信息</b>，如果您拒绝提供，我们可视为您自愿放弃此项服务。
        </p>
        <p class="indent">
          3.6
          您理解并同意，在使用本软件的一些场景中，我们可能会接入由第三方提供的软件开发包（SDK）或类似应用程序实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）或类似应用程序进行严格的安全评估，以保护您的<b>个人信息</b>安全。以下是我们接入的主要的第三方服务商的信息：
        </p>
        <p class="indent">3.6.1 阿里一键登录</p>
        <p class="indent">
          信息获取：设备标识符（IMEI、IDFA、Android
          ID、MAC、OAID等相关信息）、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息（网络信息包括：IP地址，WiFi信息，基站信息等相关信息。）
        </p>
        <p class="indent">业务场景：进行手机号一键登录</p>
        <p class="indent">隐私协议地址:</p>
        <p class="indent">
          https://terms.alicdn.com/legal-agreement/terms/suit_bu1_alibaba_communication/suit_bu1_alibaba_communication201802011704_56576.html?spm=a2c4g.11186623.2.11.149c3f784X57Kb
        </p>
        <p class="indent">3.6.2 友盟埋点SDK&ZeroWidthSpace;</p>
        <p class="indent">
          信息获取：SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、国际移动设备识别码（IMEII/android
          ID/IDFA/OPENUDID/IP地址/GUID、SIM 卡 IMSI
          信息）、设备型号、设备序列号、传感器参数、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力
        </p>
        <p class="indent">业务场景：统计分析</p>
        <p class="indent">隐私协议地址:</p>
        <p class="indent">https://www.umeng.com/page/policy</p>
        <p class="indent">
          3.6.3 QQ分享/登录SDK&ZeroWidthSpace;&ZeroWidthSpace;
        </p>
        <p class="indent">
          信息获取：<b
            >设备信息、存储权限、网络信息、IP地址、位置信息、通讯日志信息、服务日志信息以及其他相关信息</b
          >
        </p>
        <p class="indent">业务场景：账号授权、社交平台分享</p>
        <p class="indent">隐私协议地址:</p>
        <p class="indent">
          https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl
        </p>
        <p class="indent">3.6.4 新浪微博SDK&ZeroWidthSpace;&ZeroWidthSpace;</p>
        <p class="indent">信息获取：设备信息、存储权限、网络信息</p>
        <p class="indent">业务场景：账号授权、社交平台分享</p>
        <p class="indent">隐私协议地址:</p>
        <p class="indent">https://open.weibo.com/wiki/开发者协议</p>

        <p class="indent">
          3.6.5 穿山甲广告SDK&ZeroWidthSpace;&ZeroWidthSpace;
        </p>
        <p class="indent">
          信息获取：设备信息、网络信息、应用信息、传感器信息、广告信息、位置信息、性能数据
        </p>
        <p class="indent">业务场景：投放广告</p>
        <p class="indent">隐私协议地址:</p>
        <p class="indent">https://www.csjplatform.com/privacy</p>
        <p class="indent">
          3.7
          您理解并同意，为了更好地为您提供服务，我们可以在您小黑屋账户下关联该账户在中文在线其他网站及客户端（包括但不限于17K、四月天客户端、汤圆创作客户端、泛读客户端等）的<b>数据记录</b>（<b>如购买记录、消费记录、书架内容</b>），同样，中文在线也可将您在小黑屋的前述<b>数据记录</b>关联至在中文在线其他网站及客户端（包括但不限于17K、四月天客户端、泛读客户端等）上的该账户上。
        </p>
        <p class="indent">
          3.8您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其他<b>个人信息</b>。
        </p>
        <p class="indent">3.9【我们存储信息的地点、期限】</p>
        <p class="indent">
          我们遵守法律法规的规定，将境内收集的用户<b>个人信息</b>存储于境内。
        </p>
        <p class="indent">
          一般而言，我们仅为实现目的所必需的最短时间保留您的<b>个人信息</b>。但在下列情况下，我们有能因需符合法律要求，更改<b>个人信息</b>的存储时间：
        </p>
        <p class="indent">·为遵守适用的法律法规等有关规定；</p>
        <p class="indent">·为遵守法院判决、裁定或其他法律程序的规定；</p>
        <p class="indent">·为遵守相关政府机关或法定授权组织的要求；</p>
        <p class="indent">·我们有理由确信需要遵守法律法规等有关规定；</p>
        <p class="indent">
          ·为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
        </p>
        <p class="indent">
          ·当我们的产品或服务发生停止运营的情形时，我们将采取公告等形式通知您，并在合理的期限内删除或匿名化处理您的<b>个人信息</b>。
        </p>
        <p class="indent">
          ·如需要【注销账号】，可确保自己保存好本地内容，并联系我们为您处理。
        </p>
        <p>四、通知和送达</p>
        <p class="indent">
          4.1
          本协议项下所有的通知均可通过本软件重要页面公告、电子邮件、短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。
        </p>
        <p>五、其他</p>
        <p class="indent">
          5.1
          您使用本软件即视为您已阅读并同意受本协议的约束。中文在线有权在必要时修改本协议条款。您可以在本软件的最新版本中查阅相关协议条款，中文在线亦会在本软件内显著地方公示。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。
        </p>
        <p class="indent">5.2本协议签订地为中华人民共和国北京市东城区。</p>
        <p class="indent">
          5.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
        </p>
        <p class="indent">
          5.4若您和中文在线之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
        </p>
        <p class="indent">
          5.5
          本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
        </p>
        <p class="indent">
          5.6
          本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        </p>
        <p>特 别 声 明</p>
        <p class="indent">
          鉴于：我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。
        </p>
        <p class="indent">中文在线在此依法做出特别声明如下：</p>
        <p class="indent">
          中文在线采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中中文在线以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”等形式用语的条款），该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款。
        </p>
        <p class="indent">
          用户如有任何需要说明条款的要求，请立即停止使用服务，同时立即联系本软件官方客服人员，若用户未发送内含说明条款要求的邮件至本软件官方客服人员而选择同意该协议，则双方在此确认中文在线已依法履行了根据用户要求对相关条款进行说明的法定义务，中文在线已给予用户充足的时间与充分的选择权来决定是否缔结本协议。
        </p>
        <p class="indent">
          用户确认已经充分阅读本协议第3.1、3.3、3.3.1、3.3.2、3.3.3.4、3.4、3.5、3.6、3.7、5.1、5.2、5.3、5.4条款，明确理解以上协议条款的含义，完全注意并同意了本协议所有条款的合法性及有效性。
        </p>
      </div>
    </div>
    <div class="copy">Copyright © 2019 中文在线版权所有</div>
  </div>
</template>

<script>
export default {
  name: 'intro',
  data() {
    return {}
  },
  created() {}
}
</script>

<style lang="stylus" scoped>
.page {
  background:#fff url(//static.17k.com/www/skin/all/logo_old.png) repeat center 21px /240px;
}
.content{
  margin: 0 auto;
  max-width: 1000px;
}
.content >div {
  padding: 0.8em 0;
}

h1 {
  display: none;
}
  p{overflow:hidden;white-space:normal; word-break:break-all;text-overflow:ellipsis;}
.content h3, .content p {
  margin: 0;
  font-weight: normal;
  font-size: 1em;
  color: #262626;
  line-height: 22px;
  background: #f5f5ef;
  padding: 0 2em;
}
.header a.back{
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  min-width: 3.5em;
  text-align: center;
  height: 3.5em;
  position: absolute;
  display: block;
  background: url(//static.17k.com/h5/skin/arrow/arr_left.png) no-repeat center/ 80%;
}
.content h3{
  background: #e8e7db;
  text-align: center;
  line-height: 4em;
  font-size: 1.2em;
}
.content p.indent {
  background: none;
  text-indent: 2em;
}
.content p.bold {
      font-weight: bold;
}
.header{
  height: 3.5em;
  margin: 1em auto;
  max-width: 1000px;
}
.header_0{
  background: url("//static.17k.com/www/pic/logo/logo_index.png") no-repeat center/contain;;
}
.header_1{
  background: url("//static.17k.com/pic/4yt_logo.png") no-repeat center/contain;;
}

.header_2{
  background: url("//static.17k.com/pic/fd_logo.png") no-repeat center/contain;;
}

  .header_3{
  background: url("http://www.mochiwang.com/index/wp-content/themes/newlw/skin/new_index/logo.png") no-repeat center/contain;;
}
  .header_5{
  background: url("//static.17k.com/pic/wanzhangbook_logo.com.png") no-repeat center/contain;;
}
.copy{
  margin: 3em 0;
  color: #999;
  text-align: center;
}
</style>
